import { defineMessages } from 'react-intl';

type MessageKeys =
	| 'profileCardViewProfileButton'
	| 'viewCodeButtonLabel'
	| 'loadingMarkdownMessage'
	| 'loadingChartMessage'
	| 'disabledAgentMentionTooltip';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		profileCardViewProfileButton: {
			id: 'ai-mate.content-renderer.profile-card.view-profile-button',
			defaultMessage: 'View profile',
			description: 'Label for the view profile button when showing a mention in the renderer',
		},
		viewCodeButtonLabel: {
			id: 'ai-mate.content-renderer.view-code-button-label',
			defaultMessage: 'View analysis',
			description: 'Label for the view code button when showing a code block in the renderer',
		},
		loadingMarkdownMessage: {
			id: 'ai-mate.content-renderer.loading-markdown',
			defaultMessage: 'Loading markdown...',
			description:
				'Fallback loading message displayed while expandable markdown content is being loaded. Shown as a temporary placeholder inside an expandable section until the markdown component is ready to render.',
		},
		loadingChartMessage: {
			id: 'ai-mate.content-renderer.loading-chart',
			defaultMessage: 'Loading chart...',
			description:
				'Loading message displayed while a visualization chart is being loaded. Shown as a temporary placeholder until the VisualizationChart component is ready to render.',
		},
		disabledAgentMentionTooltip: {
			id: 'ai-mate.content-renderer.disabled-agent-mention-tooltip',
			defaultMessage: 'Only one agent can be active at a time',
			description:
				'Tooltip text shown when hovering or focusing a disabled (greyed-out) agent mention chip in a sent chat message. Displayed as the content of a tooltip anchored to the chip. The chip appears greyed out because the user @-mentioned multiple agents in the same prompt but only one agent responded. The purpose is to explain why the chip is non-interactive and disabled.',
		},
	});

export default message;
